import {
  EmptyCard,
  type EmptyCardProps,
} from "../../../Cards/EmptyCard/EmptyCard";

type MobileTableEmptyProps = {
  emptyState: EmptyCardProps;
};

export function MobileTableEmpty({ emptyState }: MobileTableEmptyProps) {
  return (
    <EmptyCard
      {...emptyState}
      className="border-0 rounded-none shadow-none! min-h-0 h-auto py-4"
    />
  );
}
